import DataAccess from './constants';
import { genfunction } from '../helpers';

const path = 'CountryAndStates'

export const apiCountryAndState = () => {

    var h = new Headers();
    h.append("Authorization", 'Basic ' + genfunction.EncodeBase64(DataAccess.userName + ':' + DataAccess.password));
    h.append('Content-Type', 'application/json');

    let url = DataAccess.apiUrl + path ;
    const req = new Request(url, {
        method: 'GET',
        headers: h
    })

    return fetch(req);
}